import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { Tooltip, Text } from "@nxt-costco-com/forge-components";
import { FontWeightBold } from "@nxt-costco-com/forge-design-tokens";
import { Info } from "@nxt-costco-com/forge-icons";
import { priceFullfillmentBoxStyles, priceIconBtStyles, priceFullfillmentTextStyles, priceIconStyles } from "./styles.js";
import { CostcoBox } from "../../Util/CostcoBox.js";
const PriceTooltipComponent = ({
  id,
  priceListData
}) => {
  const { priceValue, fulfillmentTexts } = priceListData || {};
  if (!fulfillmentTexts)
    console.error("No fulfillmentTexts provided in priceListData");
  const { label, tooltipTitle, tooltip, iconAriaLabel } = fulfillmentTexts || {};
  if (!label || !priceValue) return null;
  const tooltipContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    tooltipTitle && /* @__PURE__ */ jsx(Text, { variant: "b1", fontWeight: FontWeightBold, children: tooltipTitle }),
    tooltip && /* @__PURE__ */ jsx(Text, { variant: "b1", children: tooltip })
  ] });
  if (!tooltip && !tooltipTitle)
    console.log(
      "No tooltip content provided, the product fullfillment info icon is not displayed"
    );
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      "data-testid": `priceTooltipBox_${id}`,
      sx: priceFullfillmentBoxStyles,
      children: /* @__PURE__ */ jsx(
        Tooltip,
        {
          buttonContent: /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Text,
              {
                sx: priceFullfillmentTextStyles,
                uniqueId: `priceFullfillment_${id}`,
                variant: "l2",
                children: label
              }
            ),
            /* @__PURE__ */ jsx(
              Info,
              {
                "data-testid": `tooltipIcon_${id}`,
                sx: priceIconStyles
              }
            )
          ] }),
          buttonStyles: priceIconBtStyles,
          content: tooltipContent,
          hasArrow: true,
          buttonAriaLabel: iconAriaLabel || "additional information",
          tooltipId: `priceTooltip_${id}`,
          uniqueId: `priceTooltip_${id}`
        }
      )
    }
  );
};
const PriceTooltip = memo(PriceTooltipComponent);
PriceTooltip.displayName = "PriceTooltip";
export {
  PriceTooltip
};
